module.exports = __webpack_public_path__ + "img/quad-temperature-lg.a735e41f.svg";